import { render } from "./ReferidosHistoricos.vue?vue&type=template&id=8403a276"
import script from "./ReferidosHistoricos.vue?vue&type=script&lang=js"
export * from "./ReferidosHistoricos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__